<p-toast key="shipment-instruction-message" position="top-right"></p-toast>

<div class="p-mt-4">
    <p-breadcrumb [home]="home" [model]="breadcrumbMenuModel"></p-breadcrumb>
</div>

<div class="p-mt-3">

    <!--Shipment Instruction Card-->
    <div class="card p-shadow-4">

        <!--Header-->
        <div class="p-grid p-jc-center p-jc-md-between p-ai-center p-mb-3 divider-bottom">
            <div class="p-col-6 p-md-3 p-text-left">
                <h5 class="p-m-0 p-text-primary">Shipping Instructions</h5>
            </div>
            <div class="p-col-6 p-text-right p-d-none p-d-xl-block">
                <img *ngIf="!isDownloadingFile" pRipple (click)="generateSIPreviewPDF(siPreview)"
                     src="assets/branding/shared-icons/export-pdf.svg"
                     alt=""
                     class="fp-icon-height p-cursor">
                <i *ngIf="isDownloadingFile" class="pi pi-spinner pi-spin p-text-secondary"
                   style="font-size: 1.5rem;"></i>
            </div>
        </div>

        <!--Loader-->
        <div *ngIf="isLoading" class="p-d-flex p-ai-center p-jc-center" style="min-height: 400px;">
            <div class="p-text-center p-text-secondary">
                <div>
                    <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
                </div>
                <div class="p-text-bold p-mt-2">
                    Getting Shipment Instructions, Please Wait !
                </div>
            </div>
        </div>

        <!--SI Not Available Message-->

        <div *ngIf="isLoading" class="p-d-flex p-ai-center p-jc-center" style="min-height: 400px;">

        </div>

        <!--Shipment Instruction Form-->
        <div #siPreview id="siPreview" [formGroup]="shipmentInstructionForm">

            <!--Shipment Details-->
            <div class="divider-bottom p-pb-4">
                <div class="p-grid">
                    <div class="p-col-6 p-md-3">
                        <div class="fp-shipment-header p-p-2">
                            <h5 class="p-m-0">SHIPMENT DETAILS</h5>
                        </div>
                    </div>
                </div>

                <div class="p-grid p-mt-2">
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <div class="p-field">
                            <label #receiptPlace> Place of Receipt </label>
                            <p-autoComplete [disabled]="true" [dropdown]="false"
                                            appendTo="body"
                                            formControlName="placeOfReceipt"
                                            styleClass="width-100 si-autocomplete"></p-autoComplete>
                        </div>
                        <div>
                            <input disabled [placeholder]="receiptPlace.innerText" class="width-100"
                                   formControlName="placeOfReceiptEditable" pInputText
                                   type="text">
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <div class="p-field">
                            <label #loadPort> Port of Loading </label>
                            <p-autoComplete [disabled]="true" appendTo="body"
                                            formControlName="portOfLoading"
                                            styleClass="width-100 si-autocomplete"
                            ></p-autoComplete>
                        </div>
                        <div>
                            <input disabled [placeholder]="loadPort.innerText" class="width-100"
                                   formControlName="portOfLoadEditable" pInputText
                                   type="text">
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <div class="p-field">
                            <label #dischargePort> Port of Discharge </label>
                            <p-autoComplete [disabled]="true" appendTo="body"
                                            formControlName="portOfDischarge"
                                            styleClass="width-100 si-autocomplete"
                            ></p-autoComplete>
                        </div>
                        <div>
                            <input disabled [placeholder]="dischargePort.innerText + '*'" class="width-100"
                                   formControlName="portOfDischargeEditable" pInputText
                                   type="text">
                        </div>
                    </div>
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <div class="p-field">
                            <label #finalPlace> Final Place of Delivery </label>
                            <p-autoComplete [disabled]="true" [dropdown]="false"
                                            appendTo="body"
                                            formControlName="finalPlaceOfDelivery"
                                            styleClass="width-100 si-autocomplete"></p-autoComplete>
                        </div>
                        <div>
                            <input disabled [placeholder]="finalPlace.innerText + '*'" class="width-100"
                                   formControlName="finalPlaceOfDeliveryEditable" pInputText
                                   type="text">
                        </div>
                    </div>
                </div>
            </div>

            <!--Cargo Details / Container Details-->
            <div class="divider-bottom p-pt-4">
                <div class="p-grid width-100">
                    <div class="p-col-6 p-md-3">
                        <div class="fp-shipment-header p-p-2">
                            <h5 class="p-m-0">{{shipmentType !== 'AIR' ?
                                'CONTAINER DETAILS' : 'CARGO DETAILS'}}</h5>
                        </div>
                    </div>
                </div>

                <div class="p-mt-2">
                    <div *ngIf="shipmentType !== 'AIR' && shipmentInstruction?.siContainers?.length > 0">
                        <container-details #containerDetails
                                           [isPreviewSI]="true"
                                           [siContainers]="shipmentInstruction?.siContainers"></container-details>
                    </div>
                    <div *ngIf="shipmentType === 'AIR' && shipmentInstruction?.siContainers?.length > 0">

                        <cargo-details #cargoDetails
                                       [isPreviewSI]="true"
                                       [siContainers]="shipmentInstruction?.siContainers"
                        ></cargo-details>

                    </div>
                </div>

            </div>

            <!--Special Handling Instruction : AIR-->
            <div *ngIf="shipmentType === 'AIR'" class="divider-bottom p-pt-4 p-pb-4">
                <div class="p-grid width-100">
                    <div class="p-col-6 p-md-3">
                        <div class="fp-shipment-header p-p-2">
                            <h5 class="p-m-0">SPECIAL HANDLING INSTRUCTIONS</h5>
                        </div>
                    </div>
                </div>

                <div class="p-grid width-100 p-mt-2">
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <input disabled class="width-100" formControlName="specialHandlingInstruction"
                               pInputText placeholder="Add Notes For Your Shipment">
                    </div>
                </div>
            </div>

            <!--Party Details-->
            <div class="divider-bottom p-pt-4">
                <div class="p-grid width-100">
                    <div class="p-col-6 p-md-3">
                        <div class="fp-shipment-header p-p-2">
                            <h5 class="p-m-0">PARTY DETAILS</h5>
                        </div>
                    </div>
                </div>

                <!--Dropdowns-->
                <div class="p-mt-2">
                    <div class="p-grid width-100">

                        <!--Shipper Dropdown-->
                        <div class="p-col-12 p-md-6 p-lg-3">
                            <div class="p-field">
                                <label>
                                    Shipper * </label>

                                <p-dropdown #shipperContactDropdown
                                            [options]="shipperContacts"
                                            appendTo="body"
                                            [disabled]="true"
                                            emptyMessage="No Shipper found"
                                            formControlName="shipper"
                                            filter="true"
                                            filterBy="companyName"
                                            optionLabel="companyName"
                                            placeholder="Select..."
                                            readonly
                                            styleClass="si-dropdown">

                                    <ng-template pTemplate="footer">
                                        <div
                                                class="p-p-2 p-text-center">
                                            <i class="pi pi-spin pi-spinner p-text-secondary"
                                               style="font-size: 1.5rem;"></i>
                                        </div>
                                        <div class="p-p-2 divider-top p-cursor p-field-hover"
                                             pRipple>
                                            Create New
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>


                            <div class="p-grid p-p-2 width-100">
                                <div class="p-col-12">
                                    <div>
                                        {{shipmentInstructionForm?.value?.shipper?.companyName
                                        ? shipmentInstructionForm?.value?.shipper?.companyName : ''}}
                                    </div>
                                    <div class="p-text-bold">
                                        (Print on BL)
                                    </div>
                                    <div class="p-mt-2">
                                        {{shipmentInstructionForm?.value?.shipper?.address
                                        ? shipmentInstructionForm?.value?.shipper?.address : ''}}
                                    </div>

                                    <div class="p-mt-2">
                                        {{shipmentInstructionForm?.value?.shipper?.emailId
                                        ? shipmentInstructionForm?.value?.shipper?.emailId : ''}}
                                    </div>

                                    <div class="p-mt-2">
                                        {{shipmentInstructionForm?.value?.shipper?.phoneNumber
                                        ? shipmentInstructionForm?.value?.shipper?.phoneNumber : ''}}
                                    </div>
                                </div>


                            </div>
                        </div>

                        <!--Consignee Dropdown-->
                        <div class="p-col-12 p-md-6 p-lg-3">
                            <div class="p-field">
                                <label>
                                    Consignee * </label>
                                <p-dropdown
                                        appendTo="body"
                                        emptyMessage="No Consignee found"
                                        formControlName="consignee"
                                        [disabled]="true"
                                        optionLabel="companyName"
                                        filter="true"
                                        filterBy="companyName"
                                        [options]="consigneeContacts"
                                        placeholder="Select..."
                                        readonly
                                        styleClass="si-dropdown">
                                    <ng-template pTemplate="footer">
                                        <div class="p-p-2 divider-top p-cursor p-field-hover"
                                             pRipple>
                                            Create New
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>


                            <div class="p-grid p-p-2 width-100">
                                <div class="p-col-12">
                                    <div>
                                        {{shipmentInstructionForm?.value?.consignee?.companyName
                                        ? shipmentInstructionForm?.value?.consignee?.companyName : ''}}
                                    </div>
                                    <div class="p-text-bold">
                                        (Print on BL)
                                    </div>
                                    <div class="p-mt-2">
                                        {{shipmentInstructionForm?.value?.consignee?.address
                                        ? shipmentInstructionForm?.value?.consignee?.address : ''}}
                                    </div>
                                    <div class="p-mt-2">
                                        {{shipmentInstructionForm?.value?.consignee?.emailId
                                        ? shipmentInstructionForm?.value?.consignee?.emailId : ''}}
                                    </div>
                                    <div class="p-mt-2">
                                        {{shipmentInstructionForm?.value?.consignee?.phoneNumber
                                        ? shipmentInstructionForm?.value?.consignee?.phoneNumber : ''}}
                                    </div>

                                </div>
                            </div>
                        </div>

                        <!--First Notify Party Dropdown-->
                        <div class="p-col-12 p-md-6 p-lg-3">
                            <div class="p-field">
                                <label> First Notify Party </label>
                                <p-dropdown
                                        appendTo="body"
                                        filter="true"
                                        filterBy="companyName"
                                        emptyMessage="No Party Info found"
                                        formControlName="firstNotifyParty"
                                        optionLabel="companyName"
                                        placeholder="Select..."
                                        [disabled]="true"
                                        [options]="firstNotifyPartyContacts"
                                        readonly
                                        styleClass="si-dropdown">
                                    <ng-template pTemplate="footer">
                                        <div class="p-p-2 divider-top p-cursor p-field-hover"
                                             pRipple>
                                            Create New
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>

                            <div class="p-grid p-p-2 width-100">
                                <div class="p-col-12">
                                    <div>
                                        {{shipmentInstructionForm?.value?.firstNotifyParty?.companyName
                                        ? shipmentInstructionForm?.value?.firstNotifyParty?.companyName : ''}}
                                    </div>
                                    <div class="p-text-bold">
                                        (Print on BL)
                                    </div>
                                    <div class="p-mt-2">
                                        {{shipmentInstructionForm?.value?.firstNotifyParty?.address
                                        ? shipmentInstructionForm?.value?.firstNotifyParty?.address : ''}}
                                    </div>
                                    <div class="p-mt-2">
                                        {{shipmentInstructionForm?.value?.firstNotifyParty?.emailId
                                        ? shipmentInstructionForm?.value?.firstNotifyParty?.emailId : ''}}
                                    </div>
                                    <div class="p-mt-2">
                                        {{shipmentInstructionForm?.value?.firstNotifyParty?.phoneNumber
                                        ? shipmentInstructionForm?.value?.firstNotifyParty?.phoneNumber : ''}}

                                    </div>
                                </div>
                            </div>

                        </div>

                        <!--Second Notify Party Dropdown-->
                        <div class="p-col-12 p-md-6 p-lg-3">
                            <div class="p-field">
                                <label> Second Notify Party </label>
                                <p-dropdown
                                        [disabled]="true"
                                        filter="true"
                                        filterBy="companyName"
                                        appendTo="body"
                                        emptyMessage="No Party Info found"
                                        formControlName="secondNotifyParty"
                                        optionLabel="companyName"
                                        placeholder="Select..."
                                        [options]="secondNotifyPartyContacts"
                                        readonly
                                        styleClass="si-dropdown">
                                    <ng-template pTemplate="footer">
                                        <div class="p-p-2 divider-top p-cursor p-field-hover"
                                             pRipple>
                                            Create New
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>


                            <div class="p-grid p-p-2 width-100">
                                <div class="p-col-12">
                                    <div>
                                        {{shipmentInstructionForm?.value?.secondNotifyParty?.companyName
                                        ? shipmentInstructionForm?.value?.secondNotifyParty?.companyName : ''}}
                                    </div>
                                    <div class="p-text-bold">
                                        (Print on BL)
                                    </div>
                                    <div class="p-mt-2">
                                        {{shipmentInstructionForm?.value?.secondNotifyParty?.address
                                        ? shipmentInstructionForm?.value?.secondNotifyParty?.address : ''}}
                                    </div>
                                    <div class="p-mt-2">
                                        {{shipmentInstructionForm?.value?.secondNotifyParty?.emailId
                                        ? shipmentInstructionForm?.value?.secondNotifyParty?.emailId : ''}}
                                    </div>
                                    <div class="p-mt-2">
                                        {{shipmentInstructionForm?.value?.secondNotifyParty?.phoneNumber
                                        ? shipmentInstructionForm?.value?.secondNotifyParty?.phoneNumber : ''}}
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!--Cargo Description-->
            <div class="divider-bottom p-pt-4 p-pb-4">
                <div class="p-grid width-100">
                    <div class="p-col-6 p-md-3">
                        <div class="fp-shipment-header p-p-2">
                            <h5 class="p-m-0">CARGO DESCRIPTION *</h5>
                        </div>
                    </div>
                </div>

                <div class="p-grid width-100 p-mt-2 p-jc-between p-ai-start">
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div>
                            <pre
                                #cargoDescription>{{shipmentInstructionForm?.value?.cargoDescription ? shipmentInstructionForm?.value?.cargoDescription : 'Not Avaiable'}}</pre>
                            <!--                                                        <textarea #cargoDescription [maxlength]="3500" class="width-100"-->
                            <!--                                                                  formControlName="cargoDescription"-->
                            <!--                                                                  pInputTextarea-->
                            <!--                                                                  placeholder="Description of Goods" rows="7"></textarea>-->
                        </div>
                        <div *ngIf="shipmentInstruction?.value?.cargoDescriptionAddon" class="p-pt-3">
                            {{shipmentInstructionForm?.value?.cargoDescriptionAddon ? shipmentInstructionForm?.value?.cargoDescriptionAddon : 'Not Avaiable'}}
                        </div>

                    </div>
                    <div class="p-col-12 p-md-6 p-lg-6">
                        <div class="p-d-flex p-jc-between p-ai-center width-100">
                            <div>
                                <h5 class="p-m-0" style="opacity: .7;"> Upload Documents</h5>
                            </div>
                            <div class="width-100">
                                <div *ngIf="shipmentInstructionForm?.value?.siDocuments?.length === 0 || !shipmentInstructionForm?.value?.siDocuments">
                                    No Documents Uploaded !
                                </div>
                                <div *ngFor="let siDocs of shipmentInstructionForm?.value?.siDocuments; let i=index"
                                     class="p-d-flex p-jc-between p-ai-center">
                                    <div class="p-py-2">
                                        {{siDocs?.name ? siDocs?.name : ''}}
                                    </div>
                                    <div>
                                        <button *ngIf="siDocs?.siDocId"
                                                pButton
                                                class="p-button-text p-button-danger"
                                                icon="pi pi-trash"
                                                pRipple
                                                type="button"></button>

                                        <button *ngIf="!siDocs?.siDocId"
                                                pButton
                                                class="p-button-text p-button-danger"
                                                icon="pi pi-times"

                                                pRipple
                                                type="button"></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--Marks & Numbers-->
            <div *ngIf="shipmentType !== 'AIR'" class="divider-bottom p-pt-4 p-pb-4">
                <div class="p-grid width-100">
                    <div class="p-col-6 p-md-3">
                        <div class="fp-shipment-header p-p-2">
                            <h5 class="p-m-0">MARKS & NUMBERS</h5>
                        </div>
                    </div>
                </div>

                <div class="p-grid width-100 p-mt-2 p-ai-start width-100">
                    <div class="p-col-12 p-md-6 p-lg-3 p-mt-3">
                        <div class="p-d-flex p-ai-center p-jc-start width-100">
                            <div>
                                <div class="p-field-radiobutton">
                                    <p-radioButton
                                            [disabled]="true"
                                            [formControl]="shipmentInstructionForm?.get('isMarksAndNumber')"
                                            [style]="{position: 'relative'}"
                                            [value]="true"
                                            name="isMarksAndNumber"></p-radioButton>
                                    <label>Yes</label>
                                </div>
                            </div>
                            <div style="margin-left: 5rem;">
                                <div class="p-field-radiobutton">
                                    <p-radioButton
                                            [disabled]="true"
                                            [formControl]="shipmentInstructionForm?.get('isMarksAndNumber')"
                                            [style]="{position: 'relative'}"
                                            [value]="false"
                                            name="isMarksAndNumber"></p-radioButton>
                                    <label>No</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-12 p-md-6 p-lg-3">
                        {{shipmentInstructionForm?.value?.marksAndNumber ? shipmentInstructionForm?.value?.marksAndNumber : 'N/A'}}
                    </div>
                </div>
            </div>

            <!--Freight Payment Terms-->
            <div class="divider-bottom p-pt-4 p-pb-2">
                <div class="p-grid width-100">
                    <div class="p-col-6 p-md-3">
                        <div class="fp-shipment-header p-p-2">
                            <h5 class="p-m-0">FREIGHT PAYMENT TERMS *</h5>
                        </div>
                    </div>
                </div>

                <div class="p-grid width-100 p-mt-2 p-jc-between p-ai-start width-100">
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <div class="p-d-flex p-ai-center p-jc-start width-100">
                            <div>
                                <div class="p-field-radiobutton">
                                    <p-radioButton [disabled]="true" [style]="{position: 'relative'}"
                                                   [value]="'prepaid'"
                                                   [formControl]="shipmentInstructionForm?.get('freightTerm')"
                                                   name="freightTerm"></p-radioButton>
                                    <label>Prepaid</label>
                                </div>
                            </div>
                            <div style="margin-left: 5rem;">
                                <div class="p-field-radiobutton">
                                    <p-radioButton [disabled]="true" [style]="{position: 'relative'}"
                                                   [value]="'collect'"
                                                   [formControl]="shipmentInstructionForm?.get('freightTerm')"
                                                   name="freightTerm"></p-radioButton>
                                    <label>Collect</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--Special Instructions-->
            <div class="divider-bottom p-pt-4 p-pb-2">
                <div class="p-grid width-100">
                    <div class="p-col-6 p-md-3">
                        <div class="fp-shipment-header p-p-2">
                            <h5 class="p-m-0">SPECIAL INSTRUCTIONS</h5>
                        </div>
                    </div>
                </div>

                <div class="p-grid width-100 p-mt-2 p-jc-between p-ai-start width-100">
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <input type="text" disabled formControlName="specialInstruction" pInputText
                               placeholder="Add Notes For Shipment" class="width-100">
                    </div>
                </div>
            </div>

            <!--Customer Reference Number-->
            <div class="divider-bottom p-pt-4 p-pb-2">
                <div class="p-grid width-100">
                    <div class="p-col-6 p-md-3">
                        <div class="fp-shipment-header p-p-2">
                            <h5 class="p-m-0">CUSTOMER REFERENCE NUMBER</h5>
                        </div>
                    </div>
                </div>

                <div class="p-grid width-100 p-mt-2 p-jc-between p-ai-start width-100">
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <input type="text" disabled formControlName="customerReferenceNumber" pInputText
                               class="width-100">
                    </div>
                </div>
            </div>

            <!--L\C Shipment-->
            <div class="divider-bottom p-pt-4 p-pb-2">
                <div class="p-grid width-100">
                    <div class="p-col-6 p-md-3">
                        <div class="fp-shipment-header p-p-2">
                            <h5 class="p-m-0">L/C SHIPMENT</h5>
                        </div>
                    </div>
                </div>

                <div class="p-grid width-100 p-mt-2 p-jc-between p-ai-start width-100">
                    <div class="p-col-12 p-md-6 p-lg-3 p-mt-3">
                        <div class="p-d-flex p-ai-center p-jc-start width-100">
                            <div>
                                <div class="p-field-radiobutton">
                                    <p-radioButton [disabled]="true" [style]="{position: 'relative'}" [value]="true"
                                                   [formControl]="shipmentInstructionForm?.get('isLcShipment')"
                                                   name="isLcShipment"></p-radioButton>
                                    <label>Yes</label>
                                </div>
                            </div>
                            <div style="margin-left: 5rem;">
                                <div class="p-field-radiobutton">
                                    <p-radioButton [disabled]="true" [style]="{position: 'relative'}" [value]="false"
                                                   [formControl]="shipmentInstructionForm?.get('isLcShipment')"
                                                   name="isLcShipment"></p-radioButton>
                                    <label>No</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-12 p-md-6 p-lg-3">
                        <input type="text" formControlName="lcNotes" pInputText
                               placeholder="Add Notes For Shipment"
                               disabled
                               class="width-100">
                    </div>

                    <div class="p-col-0 p-md-0 p-lg-3"></div>

                    <div class="p-col-12 p-md-6 p-lg-3">
                        <div class="p-d-flex p-jc-between p-ai-center">
                            <div>
                                <h5 class="p-m-0" style="opacity: .7;"> L/C Documents (PDF only)</h5>
                                <small class="p-text-warning">Max Filesize: 20MB</small>
                            </div>
                            <div>
                                <p-fileUpload #fileUploadLC class="fp-file-upload" mode="basic"
                                              [maxFileSize]="2e+7"
                                              [invalidFileSizeMessageSummary]="'Invalid File Size'"
                                              [invalidFileSizeMessageDetail]="'File size is greater than 20MB'"
                                              accept="application/pdf"
                                              chooseIcon="pi pi-upload"
                                              [customUpload]="true"
                                              styleClass="p-button-secondary p-d-none"></p-fileUpload>
                            </div>
                        </div>

                        <div class="p-pt-2 p-text-secondary p-text-wrap">
                            {{'Uploaded File : ' + shipmentInstructionForm?.value?.lcDocument?.name}}
                        </div>
                    </div>
                </div>
            </div>

            <!--Original Docs-->
            <div class="divider-bottom p-pt-4 p-pb-2" *ngIf="shipmentType === 'AIR'">
                <div class="p-grid width-100">
                    <div class="p-col-8 p-md-5">
                        <div class="fp-shipment-header p-p-2">
                            <h5 class="p-m-0">ORIGINAL DOCUMENTS TO BE MOVE ALONG SHIPMENT</h5>
                        </div>
                    </div>
                </div>

                <div class="p-grid width-100 p-mt-2 p-jc-between p-ai-start width-100">
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <div class="p-d-flex p-ai-center p-jc-start width-100">
                            <div>
                                <div class="p-field-radiobutton">
                                    <p-radioButton [disabled]="true" [style]="{position: 'relative'}" [value]="true"
                                                   [formControl]="shipmentInstructionForm?.get('isOriginalDocument')"
                                                   name="isOriginalDocumentTrue"></p-radioButton>
                                    <label>Yes</label>
                                </div>
                            </div>
                            <div style="margin-left: 5rem;">
                                <div class="p-field-radiobutton">
                                    <p-radioButton [disabled]="true" [style]="{position: 'relative'}" [value]="false"
                                                   [formControl]="shipmentInstructionForm?.get('isOriginalDocument')"
                                                   name="isOriginalDocumentTrue"></p-radioButton>
                                    <label>No</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>
